module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_8003.3fda38ad.png";